//const API_BASE = "http://localhost:8000"; // FastAPI server
//const API_BASE = process.env.REACT_APP_API_BASE;
const API_BASE = ""; 
console.log("API_BASE:", API_BASE);
// Option 2: Use a proxy (if you want to keep /store-chapter)

// Inside your React project, edit package.json and add:

// "proxy": "http://localhost:8000"

// Then restart npm start.
// Now, fetch("/store-chapter") will forward to FastAPI automatically.
// Store chapter text once in backend cache

export async function resetCache() {
  try {
    const res = await fetch(`${API_BASE}/reset-cache?confirm=true`, {
      method: "POST",
    });
    if (!res.ok) throw new Error(`Server error: ${res.status}`);
    return await res.json();
  } catch (error) {
    console.error("Failed to reset cache:", error);
    return { status: "error" };
  }
}


export async function storeChapter(book_id, chapter_number, text) {
  const response = await fetch(`${API_BASE}/store-chapter?version=${Date.now()}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ book_id, chapter_number, text }),
  });

  if (!response.ok) {
    throw new Error(`Failed to store chapter: ${response.status}`);
  }

  return response.json();
}
export async function generateQuestions(chapterText) {
  try {
    const res = await fetch(`${API_BASE}/generate-questions?version=${Date.now()}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        book_id: "book123",
        chapter_number: 1,
        text: chapterText,
      }),
    });

    if (!res.ok) throw new Error(`Server error: ${res.status}`);

    const data = await res.json();

    console.log("Backend response for generateQuestions:", data); // ✅ Log backend answer here

    return {
      questions: Array.isArray(data.questions) ? data.questions : [],
    };
  } catch (error) {
    console.error("Failed to generate questions:", error);
    return { questions: [] };
  }
}

// Grade ONE answer
export async function gradeSingleAnswer(question, answer, userId = "user1") {
  try {
    const res = await fetch(`${API_BASE}/grade-answer?version=${Date.now()}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_id: userId,
        question: question,
        answer: answer,
      }),
    });

    if (!res.ok) throw new Error(`Server error: ${res.status}`);
    const data = await res.json();
    console.log("Backend response for gradeSingleAnswer:", data);
    return {
      feedback: Array.isArray(data.feedback) ? data.feedback : [],
    };
  } catch (error) {
    console.error("Failed to generate questions:", error);
    return { questions: [] };
  }
}

// Grade ALL answers in one request
export async function gradeAllAnswers(questions, answers, userId = "user1") {
  try {
    // Build responses array of QAItem objects
    const responses = questions.map((q, idx) => ({
      question: q,
      answer: answers[idx] || "",
    }));

    const res = await fetch(`${API_BASE}/grade-all-answers?version=${Date.now()}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_id: userId,
        responses: responses,
      }),
    });

    if (!res.ok) throw new Error(`Server error: ${res.status}`);
    return await res.json();
  } catch (error) {
    console.error("Failed to grade all answers:", error);
    return { feedback: [] };
  }
}

// Grade ALL answers using semantic similarity in one request
export async function semanticEvaluate(questions, answers, userId = "user1"){
   try {
    const res = await fetch(`${API_BASE}/semantic-evaluate?version=${Date.now()}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        questions,
        answers,
      }),
    });

    if (!res.ok) throw new Error(`Server error: ${res.status}`);

    const data = await res.json();
    console.log("semantic evaluation",data);
    return data;
    
  } catch (err) {
    console.error("Semantic Evaluation failed:", err);
  }
  }

  // Grade ALL answers using Langchain evaluation in one request
export async function langchainEvaluate(questions, answers, userId = "user1"){
   try {
    const res = await fetch(`${API_BASE}/langchain-evaluate?version=${Date.now()}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        questions,
        answers,
      }),
    });

    if (!res.ok) throw new Error(`Server error: ${res.status}`);

    const data = await res.json();
    console.log("langchain evaluation",data);
    return data;   
  } catch (err) {
    console.error("Langchain Evaluation failed:", err);
  }
  }